/**
 * Poker Constants - Shared across all poker variants
 */

export const SUITS = {
  SPADES: { name: 'Spades', symbol: '♠', color: '#1e293b', order: 4 },
  HEARTS: { name: 'Hearts', symbol: '♥', color: '#dc2626', order: 3 },
  DIAMONDS: { name: 'Diamonds', symbol: '♦', color: '#dc2626', order: 2 },
  CLUBS: { name: 'Clubs', symbol: '♣', color: '#1e293b', order: 1 }
};

export const RANKS = {
  2: { value: 2, display: '2' },
  3: { value: 3, display: '3' },
  4: { value: 4, display: '4' },
  5: { value: 5, display: '5' },
  6: { value: 6, display: '6' },
  7: { value: 7, display: '7' },
  8: { value: 8, display: '8' },
  9: { value: 9, display: '9' },
  10: { value: 10, display: '10' },
  11: { value: 11, display: 'J' },
  12: { value: 12, display: 'Q' },
  13: { value: 13, display: 'K' },
  14: { value: 14, display: 'A' }
};

// Three Card Stud hand rankings (highest to lowest)
export const THREE_CARD_HANDS = {
  STRAIGHT_FLUSH: { rank: 6, name: 'Straight Flush', payout: 40 },
  THREE_OF_A_KIND: { rank: 5, name: 'Three of a Kind', payout: 30 },
  STRAIGHT: { rank: 4, name: 'Straight', payout: 6 },
  FLUSH: { rank: 3, name: 'Flush', payout: 4 },
  PAIR: { rank: 2, name: 'Pair', payout: 1 },
  HIGH_CARD: { rank: 1, name: 'High Card', payout: 1 }
};

// Texas Hold'em hand rankings
export const HOLDEM_HANDS = {
  ROYAL_FLUSH: { rank: 10, name: 'Royal Flush' },
  STRAIGHT_FLUSH: { rank: 9, name: 'Straight Flush' },
  FOUR_OF_A_KIND: { rank: 8, name: 'Four of a Kind' },
  FULL_HOUSE: { rank: 7, name: 'Full House' },
  FLUSH: { rank: 6, name: 'Flush' },
  STRAIGHT: { rank: 5, name: 'Straight' },
  THREE_OF_A_KIND: { rank: 4, name: 'Three of a Kind' },
  TWO_PAIR: { rank: 3, name: 'Two Pair' },
  PAIR: { rank: 2, name: 'Pair' },
  HIGH_CARD: { rank: 1, name: 'High Card' }
};

// Default chip values
export const CHIP_VALUES = {
  WHITE: 1,
  RED: 5,
  BLUE: 10,
  GREEN: 25,
  BLACK: 100,
  PURPLE: 500,
  YELLOW: 1000
};

// Starting chips for new players
export const STARTING_CHIPS = 1000;

// Minimum/maximum bets for Three Card Stud
export const THREE_CARD_LIMITS = {
  MIN_ANTE: 10,
  MAX_ANTE: 100,
  ANTE_INCREMENTS: [10, 25, 50, 100]
};

// AI player names
export const AI_NAMES = [
  'Alex', 'Jordan', 'Casey', 'Morgan', 'Riley', 'Quinn',
  'Avery', 'Dakota', 'Reese', 'Skyler', 'Taylor', 'Cameron'
];

// Boosty Games Logo URL
export const BOOSTY_LOGO_URL = "https://customer-assets.emergentagent.com/job_4e3de3c9-461d-4f73-ada0-30b07137d950/artifacts/0wd7buyq_Boosty%20Games%20v2.png";
